import { createAction } from "@reduxjs/toolkit";
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCHING_NOTIFICATIONS_SUCCEDDED,
  FETCHING_NOTIFICATIONS_FAILED,
  DELETE_ALL_NOTIFICATIONS_REQUEST,
  DELETE_ALL_NOTIFICATIONS_SUCCEEDED,
  DELETE_ALL_NOTIFICATIONS_FAILED,
  MARK_NOTIFICATIONS_AS_READ,MARK_NOTIFICATIONS_AS_READ_SUCCEEDED,MARK_NOTIFICATIONS_AS_READ_FAILED,
  FETCHING_NOTIFICATIONS_COUNT_REQUEST,
  FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED,
  FETCHING_NOTIFICATIONS_COUNT_FAILED,
} from "./actionTypes";
import {FetchNotificationsRequest, FetchNotificationResponse,FetchNotificationErrorResponse, DeleteNotificationResponse, DeleteNotificationErrorResponse, UpdateNotificationResponse, UpdateNotificationErrorResponse} from "src/types/hub"

import { takeEvery, call, put } from "redux-saga/effects";
import axios from "axios";
import buildUrl from "build-url-ts";


const apiUrl = `${process.env.REACT_APP_API_URL}`;
const HUB_URL = `${apiUrl}/api/2.1/hub`;
const NOTIFICATIONS_BASE_URL = `${apiUrl}/api/2.1/notifications`;

// notification slider

export const fetchNotifications = createAction<FetchNotificationsRequest>(FETCH_NOTIFICATIONS_REQUEST);

const fetchingNotificationsSuccedded = createAction<FetchNotificationResponse>(FETCHING_NOTIFICATIONS_SUCCEDDED);

const fetchingNotificationsFailed = createAction<FetchNotificationErrorResponse>( FETCHING_NOTIFICATIONS_FAILED);

const fetchNotificationsSaga = function* (action: ReturnType<typeof fetchNotifications>): any {
  const { page} = action.payload; 

  const url = `${apiUrl}/api/2.1/notifications`;

  const fetchNotificationsSagaAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
      params: { page }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchNotificationsSagaAPI);
    yield put(fetchingNotificationsSuccedded(response));
  } catch (error) {
    yield put(fetchingNotificationsFailed({error: error}));
  }
};

export const fetchNotificationsCount = createAction(FETCHING_NOTIFICATIONS_COUNT_REQUEST);
const fetchingNotificationsCountSuccedded = createAction<number>(FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED);  
const fetchingNotificationsCountFailed = createAction<FetchNotificationErrorResponse>( FETCHING_NOTIFICATIONS_COUNT_FAILED);

const fetchNotificationsCountSaga = function* (action: ReturnType<typeof fetchNotifications>): any {

  var url = buildUrl(NOTIFICATIONS_BASE_URL, {
    path: `/count`
  });

  const fetchNotificationsCountSagaAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchNotificationsCountSagaAPI);
    yield put(fetchingNotificationsCountSuccedded(response));
  } catch (error) {
    yield put(fetchingNotificationsCountFailed({error: error}));
  }
};

// delete notifications
export const deleteAllNotifications = createAction(DELETE_ALL_NOTIFICATIONS_REQUEST);

const deletingAllNotificationsSucceeded = createAction<DeleteNotificationResponse>(DELETE_ALL_NOTIFICATIONS_SUCCEEDED);

const deletingAllNotificationsFailed = createAction<DeleteNotificationErrorResponse>( DELETE_ALL_NOTIFICATIONS_FAILED);

const deleteNotificationsSaga = function* (action: ReturnType<typeof fetchNotifications>): any {

  const url = `${apiUrl}/api/2.1/notifications/all`;

  const deleteNotificationsSagaAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteNotificationsSagaAPI);
    yield put(deletingAllNotificationsSucceeded(response));
  } catch (error) {
    yield put(deletingAllNotificationsFailed({error: error}));
  }
};

//updatingNotificationsAsRead

export const updatingNotificationsAsRead = createAction(MARK_NOTIFICATIONS_AS_READ);

const updatingNotificationsAsReadSuccedded = createAction<UpdateNotificationResponse>(MARK_NOTIFICATIONS_AS_READ_SUCCEEDED);

const updatingNotificationsAsReadFailed = createAction<UpdateNotificationErrorResponse>( MARK_NOTIFICATIONS_AS_READ_FAILED);

const updateNotificationsSaga = function* (action: ReturnType<typeof fetchNotifications>): any {

  const url = `${apiUrl}/api/2.1/notifications/read`;

  const updateNotificationsSagaAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateNotificationsSagaAPI);
    yield put(updatingNotificationsAsReadSuccedded(response));
  } catch (error) {
    yield put(updatingNotificationsAsReadFailed({error: error}));
  }
};




export default function* notificationSaga() {
    yield takeEvery(FETCH_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
    yield takeEvery(DELETE_ALL_NOTIFICATIONS_REQUEST, deleteNotificationsSaga);
    yield takeEvery(MARK_NOTIFICATIONS_AS_READ, updateNotificationsSaga);
    yield takeEvery(FETCHING_NOTIFICATIONS_COUNT_REQUEST, fetchNotificationsCountSaga);
}



